
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = []
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "6e286fd4b0423219d735.worker.js", { name: "[hash].worker.js" })
					addMethods(w, methods)
					
					return w
				}
			